import Request from '../common/Request';

export default class OptionConvert {

    static options(data) {

        // console.log(res.Data);
        const result = data.map((prop,key)=>{
            if(prop.user_branch_name){
                return {
                    value:prop.ulid,
                    label:prop.user_branch_name,
                    id:prop.id
                };
    
            }else{
                return {
                    value:prop.ulid,
                    label:prop.name,
                    id:prop.id,
                    picture:prop.picture
                };
    
            }
        });
        return result;
    }

    static optionsById(data) {
        const result = data.map((prop,key)=>{
            if(prop.user_branch_name){
                return {
                    value:prop.id,
                    label:prop.user_branch_name,
                    id:prop.id
                };
    
            }else{
                return {
                    value:prop.id,
                    label:prop.name,
                    id:prop.id,
                    picture:prop.picture
                };
            }
        });
        return result;
    }
}